import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as mutations from './mutations';

const initialState = {
  toast: { visible: false, text: '', timeout: 2000 },
  imgView: { visible: false, src: '' },
  orgList: { data: [], loading: false },
  loading: false,
};


export default { namespaced: true, state: initialState, mutations } as IStore<IModuleState>;
